/**
 * Сравнитель строк по предопределённому порядку. Элементы, перечисленные
 * в `order`, идут в указанной последовательности; всё остальное падает
 * в конец и сортируется между собой по алфавиту (localeCompare).
 *
 * Возвращает значение в формате `Array.prototype.sort` (отрицательное /
 * положительное / 0) — чтобы можно было пользоваться напрямую:
 *
 *   arr.sort((a, b) => sortByPredefinedOrder(a, b, ['c', 'a']));
 */
export function sortByPredefinedOrder(a: string, b: string, order?: string[] | null): number {
    if (!order || order.length === 0) {
        return a.localeCompare(b);
    }
    const ia = order.indexOf(a);
    const ib = order.indexOf(b);

    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
}
